/** Interface languages. Adding one means adding an entry here and a translation file in the web app. */
export const UI_LOCALES = ['pl', 'ru', 'en'] as const;
export type UiLocale = (typeof UI_LOCALES)[number];
/** The club speaks Polish: new visitors see Polish until they pick another language. */
export const DEFAULT_UI_LOCALE: UiLocale = 'pl';
